<div class="reactive-text-container">
  <div class="text-subcontainer">
    <span [@fadeText]="textClass" class="text">
      <ng-container [ngSwitch]="currentIndex">
        <ng-container *ngSwitchCase="0">
          El <span [ngStyle]="{ color: '#02F788', fontWeight: 'bold' }">80%</span> de nuestros clientes vuelven a solicitar un segundo financiamiento.<br>
          El <span [ngStyle]="{ color: '#02F788', fontWeight: 'bold' }">20%</span> crecen de manera efectiva.
        </ng-container>
        <ng-container *ngSwitchCase="1">
          Evaluamos <span [ngStyle]="{ color: '#02F788', fontWeight: 'bold' }">potencial</span>, no solo historial crediticio.
        </ng-container>
        <ng-container *ngSwitchCase="2">
          Más del <span [ngStyle]="{ color: '#02F788', fontWeight: 'bold' }">90%</span> de nuestros créditos se aprueban en menos de <span [ngStyle]="{ color: '#02F788', fontWeight: 'bold' }">72 horas</span>.
        </ng-container>
      </ng-container>
    </span>
  </div>
  <img class="hero-sphere-5" [src]="icons.sphere3" alt="">
</div>
